import React from "react";
import styles from "../styles/Button.module.css";

type Color = "primary" | "secondary" | "tetiary";
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "solid" | "link";
  color?: Color;
}

const getButtonColor = (color: Color) => {
  switch (color) {
    case "primary":
      return styles.btnPrimary;

    case "secondary":
      return styles.btnSecondary;

    case "tetiary":
      return styles.btnBlack

    default:
      return styles.btnPrimary;
  }
};

const Button = ({
  children,
  className,
  variant = "solid",
  color = "primary",
  ...props
}: React.PropsWithChildren<ButtonProps>) => {
  const isLink = variant === "link";
  const btnColor = getButtonColor(color);
  return (
    <button
      type="submit"
      className={`${styles.btn} ${btnColor} ${
        isLink && styles.btnLink
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

interface IconButtonProps extends ButtonProps {
  icon: React.ReactNode;
}

export const IconButton = ({
  className = "",
  icon,
  ...props
}: IconButtonProps) => {
  return (
    <button type="submit" className={`icon-btn ${className}`} {...props}>
      {icon}
    </button>
  );
};

export default Button;
